import LetterElementModel from 'letter/model/letter_element_model'

export default function fabricObjectToImageLetterElement(fabricObject, letterElement) {
  const options = {
    type: 'image',
    sortId: fabricObject._sortId,
    x: fabricObject.left,
    y: fabricObject.top,

    metaData: {
      width: fabricObject.getScaledWidth(),
      height: fabricObject.getScaledHeight(),
    },
  }

  if (letterElement) {
    letterElement.set(options)
    return letterElement
  } else {
    return new LetterElementModel(options)
  }
}
